import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { PageInfoFragment, BrandFragment } from "@shared/data/fragments";
import { PAGE_INFO_FRAGMENT } from "@shared/data/fragments";
import type { TopBrand } from "@shared/types/graphqlGenerated";

const BRANDS_QUERY = gql`
  query Brands_Shared_Query(
    $filters: BrandFilterObject
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    viewer {
      brands(filters: $filters, first: $first, last: $last, after: $after, before: $before) {
        nodes {
          id
          logo
          name
          prescriptionOnly
          topBrand {
            id
            position
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;

interface BrandSplinter extends Pick<BrandFragment, "id" | "logo" | "name" | "prescriptionOnly"> {
  topBrand: Pick<TopBrand, "id" | "position">;
}

interface BrandsData {
  viewer: {
    brands: {
      nodes: BrandSplinter[];
      pageInfo: PageInfoFragment;
      totalCount: number;
    };
  };
}

type Lists = "TOP_BRANDS" | "WITH_NEW_PRODUCTS";

interface Variables {
  filters?: {
    list?: Lists;
    active?: boolean;
  };
  first?: number;
  last?: number;
  after?: string;
  before?: string;
}

const defaultVariables: Variables = {
  first: 24,
};

const useBrandsQuery = (options?: QueryHookOptions<BrandsData, Variables>) => {
  const { variables } = { variables: {}, ...options };

  return useQuery<BrandsData, Variables>(BRANDS_QUERY, {
    ...options,
    variables: { ...defaultVariables, ...variables },
  });
};

export type { BrandSplinter, Variables, BrandsData };
export { useBrandsQuery, BRANDS_QUERY };
